import React from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';

export default function ClassForm({ currentClass, teachers, formData, onChange, onSubmit, onCancel }) {
    return (
        <div className="bg-white rounded-2xl shadow-sm p-8 border border-gray-100 max-w-4xl mx-auto animated fadeIn">
            <div className="flex justify-between items-center mb-8">
                <h2 className="text-2xl font-bold text-gray-900">{currentClass ? 'Edit Class' : 'Add New Class'}</h2>
                <button onClick={onCancel} className="text-gray-400 hover:text-gray-600"><FaTimes size={20} /></button>
            </div>
            <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Teacher</label>
                    <select
                        name="teacher_id"
                        value={formData.teacher_id}
                        onChange={onChange}
                        className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                        required
                    >
                        <option value="">Select Teacher</option>
                        {teachers.map(t => <option key={t.id} value={t.id}>{t.name} ({t.subject})</option>)}
                    </select>
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Class Name</label>
                    <input
                        name="name"
                        value={formData.name}
                        onChange={onChange}
                        className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                        placeholder="Grade 11 Theory"
                        required
                    />
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Grade</label>
                    <input
                        type="number"
                        name="grade"
                        value={formData.grade}
                        onChange={onChange}
                        className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                        placeholder="11"
                        required
                    />
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Subject</label>
                    <input
                        name="subject"
                        value={formData.subject}
                        onChange={onChange}
                        className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                        placeholder="Mathematics"
                        required
                    />
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Fee (LKR)</label>
                    <input
                        type="number"
                        name="fee"
                        value={formData.fee}
                        onChange={onChange}
                        className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                        placeholder="2500"
                        required
                    />
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Type</label>
                    <select
                        name="type"
                        value={formData.type}
                        onChange={onChange}
                        className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                    >
                        <option value="Online">Online</option>
                        <option value="Physical">Physical</option>
                    </select>
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Location</label>
                    <input
                        name="location"
                        value={formData.location}
                        onChange={onChange}
                        className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                        placeholder="Online / Gampaha"
                    />
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Schedule</label>
                    <input
                        name="class_schedule"
                        value={formData.class_schedule}
                        onChange={onChange}
                        className="w-full border rounded-xl p-3 bg-gray-50 font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                        placeholder="Tuesday 4:00 PM"
                    />
                </div>
                <div className="md:col-span-2 flex justify-end gap-3 mt-6 border-t pt-6">
                    <button type="button" onClick={onCancel} className="px-6 py-2.5 text-gray-600 font-bold hover:bg-gray-100 rounded-xl transition-all">Cancel</button>
                    <button type="submit" className="px-10 py-2.5 bg-gray-900 text-white rounded-xl font-bold hover:bg-gray-800 shadow-lg shadow-gray-200 flex items-center gap-2 active:scale-95 transition-all">
                        <FaSave /> {currentClass ? 'Update Class' : 'Create Class'}
                    </button>
                </div>
            </form>
        </div>
    );
}
